module.exports = __webpack_public_path__ + "media/images/clients/unsuccess_client-a3998b8d8881db1fe83b90225b124205.png";